import React from "react";
import "./about.css";
import AboutMe from "../../assets/about-me.svg";

function About(props) {
  return (
    <section className="about container section" id="about">
      <h2 className="section__title">About Me</h2>

      <div className="about__container grid">
        <img src={AboutMe} alt="" className="about__img" />
        <div className="about__data grid">
          <div className="about__info">
            <p className="about__description">
              Hello, I'm Anoohya Nalla, a Full Stack Developer skilled in
              JavaScript, TypeScript, React, Next.js, React Native, and Node.js.
              I specialize in developing scalable web and mobile applications,
              delivering seamless, user-centric solutions from frontend to
              backend. Passionate about crafting exceptional digital
              experiences, I constantly explore new technologies to refine my
              skills and create high-quality software.
            </p>
            <a
              href="https://drive.google.com/file/d/1bDILaq3WJISfql2uBglvZzF_o1svrEAw/view?usp=sharing"
              className="btn"
            >
              Resume
            </a>
          </div>
          <div className="about__skills grid">
            <div className="skills__data">
              <div className="skills__titles">
                <h3 className="skills__name">Web Development</h3>
                <span className="skills__number">90%</span>
              </div>

              <div className="skills__bar">
                <span className="skills__percentage web"></span>
              </div>
            </div>

            <div className="skills__data">
              <div className="skills__titles">
                <h3 className="skills__name">Mobile Development</h3>
                <span className="skills__number">80%</span>
              </div>

              <div className="skills__bar">
                <span className="skills__percentage mobile"></span>
              </div>
            </div>

            <div className="skills__data">
              <div className="skills__titles">
                <h3 className="skills__name">Artist</h3>
                <span className="skills__number">80%</span>
              </div>

              <div className="skills__bar">
                <span className="skills__percentage artist"></span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default About;
